import { styled } from "@mui/material/styles";
import ProfileLogoAsset from "assets/images/logo/profile.svg";

export const PictureContainer = styled("div", {
  label: "picture-container",
})`
  background: ${({ theme }) => theme.palette.color.gray[10]};
  display: none;
  position: relative;
  width: 100%;
  border-top-left-radius: ${({ theme }) => theme.spacing(1.75)};
  border-top-right-radius: ${({ theme }) => theme.spacing(1.75)};
  overflow: hidden;
  padding-bottom: 35%;

  ${({ theme }) => theme.breakpoints.up("md")} {
    display: block;
  }
`;

export const Picture = styled("img", {
  label: "picture",
})`
  object-fit: cover;
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 75%, transparent);
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const ProfileLogo = styled(ProfileLogoAsset, {
  label: "profile-logo",
})`
  display: none;

  ${({ theme }) => theme.breakpoints.up("md")} {
    border-radius: 100%;
    display: block;
    margin: ${({ theme }) =>
      theme.spacing(
        `clamp(${theme.spacing(-7)}, -3.9vw, ${theme.spacing(-5)})`,
        `clamp(${theme.spacing(3)}, 2.25vw, ${theme.spacing(4)})`,
        `clamp(${theme.spacing(-4)}, -2.25vw, ${theme.spacing(-3)})`,
        "auto",
      )};
    position: relative;
    width: auto;
    height: ${({ theme }) =>
      `clamp(${theme.spacing(8)}, 6.15vw, ${theme.spacing(11)})`};
  }

  .amendPayment & {
    ${({ theme }) => theme.breakpoints.up("md")} {
      margin: ${({ theme }) =>
        theme.spacing(
          `clamp(${theme.spacing(-4)}, -2.25vw, ${theme.spacing(-3)})`,
          "auto",
          `clamp(${theme.spacing(-7)}, -3.9vw, ${theme.spacing(-5)})`,
          "auto",
        )};
    }
  }
`;
